"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenInlineEditText = void 0;
var koden_inline_edit_text_1 = require("./koden-inline-edit-text");
Object.defineProperty(exports, "KodenInlineEditText", { enumerable: true, get: function () { return koden_inline_edit_text_1.KodenInlineEditText; } });
//# sourceMappingURL=index.js.map